import * as Sentry from '@sentry/react'

const DEFAULT_GLITCHTIP_DSN =
  'https://823c3a9ff8c641bdb4600197430167b9@dev.glitchtip.anlantech.cn/1'
const DEFAULT_TRACES_SAMPLE_RATE = 0.01

declare const __GLITCHTIP_DSN__: string | undefined
declare const __GLITCHTIP_RELEASE__: string | undefined

const parseSampleRate = (value: string | undefined, fallback: number) => {
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return fallback
  if (parsed < 0) return 0
  if (parsed > 1) return 1
  return parsed
}

export const getGlitchTipBrowserConfig = () => {
  const dsn = import.meta.env.VITE_GLITCHTIP_DSN || __GLITCHTIP_DSN__ || DEFAULT_GLITCHTIP_DSN
  const release = import.meta.env.VITE_GLITCHTIP_RELEASE || __GLITCHTIP_RELEASE__

  return {
    enabled: process.env.NODE_ENV === 'production' && Boolean(dsn),
    dsn,
    environment:
      import.meta.env.VITE_GLITCHTIP_ENVIRONMENT || import.meta.env.MODE || process.env.NODE_ENV,
    release: release || undefined,
    tracesSampleRate: parseSampleRate(
      import.meta.env.VITE_GLITCHTIP_TRACES_SAMPLE_RATE,
      DEFAULT_TRACES_SAMPLE_RATE
    ),
    site: import.meta.env.VITE_APP_PROJECT_NAME,
  }
}

const toError = (error: unknown) => {
  if (error instanceof Error) return error
  if (typeof error === 'string') return new Error(error)
  try {
    return new Error(JSON.stringify(error))
  } catch {
    return new Error(String(error))
  }
}

export const captureBrowserException = (
  error: unknown,
  context?: Parameters<typeof Sentry.captureException>[1]
) => {
  Sentry.captureException(toError(error), context)
}
